import { render, staticRenderFns } from "./productPointModal.vue?vue&type=template&id=4e3e9ad2&scoped=true&"
import script from "./productPointModal.vue?vue&type=script&lang=js&"
export * from "./productPointModal.vue?vue&type=script&lang=js&"
import style0 from "./productPointModal.vue?vue&type=style&index=0&id=4e3e9ad2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3e9ad2",
  null
  
)

export default component.exports